<template>
<el-dialog v-if="visible" title="拟定审批单" width="80%" :visible.sync="visible" :key="timer" append-to-body @close="cancel()">
    <el-table :data="partList" row-key="id" size="mini" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
       <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
       <!-- <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
                {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
        </el-table-column> -->
        <el-table-column prop="partCode" header-align="center" align="left" label="零件编号">
        </el-table-column>
        <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
        </el-table-column>
        <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
        </el-table-column>
        <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
        </el-table-column>
        <el-table-column prop="supplyStatus" header-align="center" align="center" label="供货状态" width="80">
            <template slot-scope="scope">
                <span>
                    {{ supplyStatusFormat(scope.row.supplyStatus) }}
                </span>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="rfqSupplierList" header-align="center" align="right" label="中标供应商">
            <template >
                <span>
                    {{ this.rfqSupplierList }}
                </span>
            </template>
        </el-table-column> -->
        <el-table-column prop="rfqSupplierList" label="中标供应商" header-align="center" align="left" width="200">
            <template slot-scope="scope">
                <el-select placeholder="下拉查看中标供应商2" v-model="rfqSupplierCode" size="small">
                    <el-option v-for="item in scope.row.rfqSupplierList" :key="item.rfqSupplierCode" :label="item.rfqSupplierName" :value="item.rfqSupplierCode"/>
                </el-select>
            </template>
        </el-table-column>
        <el-table-column header-align="center" align="left" width="190" label="操作">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="selectPartList(scope.row)" icon="el-icon-edit">
                    选择中标供应商
                </el-button>
            </template>
        </el-table-column>

    </el-table>

    <rfq-supplier-part v-if="this.partVisible" ref="rfqSupplierPart" @confirm="confirmPrepare"/>
    <div slot="footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" v-if="isAuth('sourcing:rfq:newbutton')" @click="confirm()">确认拟定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {
    getQUOTATION_STATUS_VALUE,
    SUPPLY_STATUS,
    getLabelByValue,
} from '@/utils/const'
import RfqSupplierPart from "./rfq-supplier-part";
// import moment from 'moment'
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        partList: Array,
        supplierList: Array,
        viewFlag: Boolean,
    },
    computed: {
        confimDisable() {
            if (!this.summaryList) return true
            const checked = this.summaryList.filter(v => v.rfqSupplyRadio)
            if (checked.length === 0) return true
            let sum = 0
            checked.forEach(v => {
                sum += v.rfqSupplyRadio
            })
            return !(sum === 100)
        }
    },
    data() {
        return {
            rfqId: '',
            visible: false,
            summaryList: [],
            partVisible:false,
            dataListSelections: [],
            rfqSupplierParamList:[],
            timer:'',
            rfqSupplier:'',
        }
    },
    components: {
        RfqSupplierPart
    },
    mounted() {},
    methods: {
        init(summaryList,rfqId) {
            console.log(this.partList);
            this.visible = true
            this.summaryList = summaryList
            this.rfqId = rfqId
            this.rfqSupplierParamList=[]
        },
        confirm() {
            this.$emit('confirm', this.partList)
            this.visible = false
        },
        confirmPrepare(params){
            console.log(params)
            for (let key = 0; key < this.partList.length; key++) {
                if(params.row.id === this.partList[key].id){
                    this.partList[key].rfqSupplierList =  params.suppliers
                }
            }
            console.log(this.partList);
            // 刷新当前Dialog
            this.timer = new Date().getTime();
            // this.showDetailDialog(this.id);
        },
        supplyStatusFormat(value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        handleCheckChange(val, row) {
            if (val) {
                if (this.summaryList.findIndex(v => v.rfqSupplyRadio !== 0) > -1) {
                    row.rfqSupplyRadio = 100
                } else {
                    row.rfqSupplyRadio = 0
                }
            } else {
                row.rfqSupplyRadio = 0
            }
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections.push(val);
        },
        getStatus(status) {
            return getQUOTATION_STATUS_VALUE(status)

        },
        selectPartList(row){
            this.partVisible = true
            this.$nextTick(() => {
                this.$refs.rfqSupplierPart.init(row,this.rfqId,this.summaryList)
            })
        },
        cancel() {
            this.visible = false
            this.$emit('update:visible', false)
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
    },
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
